__turbopack_context__.v({
  "headingWrapper": "BvlVYW_headingWrapper",
  "listBoxSectionWithHeader": "BvlVYW_listBoxSectionWithHeader",
  "listItem": "BvlVYW_listItem",
  "popover": "BvlVYW_popover",
  "popoverInfoContainer": "BvlVYW_popoverInfoContainer",
  "positioner": "BvlVYW_positioner",
});
